import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { BadgeCheck, ScanLine } from 'lucide-react';
import ProfilePhoto from '../../assets/checker/profile-photo.png';

const ROLES = ['Sales Executive', 'Nanny', 'Personal Assistant', 'Driver', 'Housekeeper', 'Security Officer'];

export default function ProfileCardSlider() {
  const navigate = useNavigate();
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    let swap: ReturnType<typeof setTimeout>;
    const interval = setInterval(() => {
      // fade out, swap the role, fade back in
      setVisible(false);
      swap = setTimeout(() => {
        setIndex((prev) => (prev + 1) % ROLES.length);
        setVisible(true);
      }, 300);
    }, 2600);

    return () => {
      clearInterval(interval);
      clearTimeout(swap);
    };
  }, []);

  return (
    <div className='w-full max-w-[360px] bg-white rounded-[28px] p-4 md:p-5 shadow-[0_24px_60px_-20px_rgba(0,0,0,0.25)]'>
      {/* Photo */}
      <div className='rounded-[20px] overflow-hidden bg-[#ECECEC] aspect-[214/233]'>
        <img src={ProfilePhoto} alt='Verified candidate' className='w-full h-full object-cover' />
      </div>

      {/* Name + verified badge */}
      <div className='flex items-center gap-2 mt-5'>
        <h3 className='text-gray-900 text-2xl md:text-[28px] font-bold leading-none'>Jane Doe</h3>
        <BadgeCheck className='w-6 h-6 text-[#FF6B35] fill-[#FF6B35] [&>path]:stroke-white' />
      </div>

      {/* Rotating role title */}
      <div className='h-7 mt-1 overflow-hidden'>
        <p
          className={`text-gray-500 text-base md:text-lg transition-all duration-300 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2'
          }`}
        >
          {ROLES[index]}
        </p>
      </div>

      {/* CTA */}
      <button
        type='button'
        onClick={() => navigate('/signup')}
        className='mt-5 w-full bg-black text-white rounded-full py-3.5 md:py-4 px-4 flex items-center justify-center gap-2 text-sm md:text-[15px] font-semibold whitespace-nowrap hover:bg-gray-900 transition-colors'
      >
        <ScanLine className='w-[18px] h-[18px] shrink-0' />
        Run Background Check
      </button>
    </div>
  );
}
